import type { UserId } from "@common/types/user";
import { FeatureFlagService } from "@web/src/app/services/feature-flag-service";
import { action, makeAutoObservable, observable } from "mobx";

interface FeaturesStoreDependencies {
  featureFlagService: {
    initialize: ({ userId }: { userId: UserId }) => Promise<void>;
    getFeatureEnabled: (flagKey: string, comparisonValue?: string) => boolean;
  };
}

export default class FeaturesStore {
  @observable
  features = {
    spaceSharing: false,
    /** Amplitude Experiment flag key: `slash_remind_command` (variant value `on` enables). */
    slashRemindCommand: false,
  };

  constructor(readonly deps: FeaturesStoreDependencies) {
    makeAutoObservable(this);
  }

  @action
  async initialise({ userId }: { userId: UserId }) {
    await this.deps.featureFlagService.initialize({ userId });
    // this.features.spaceSharing =
    //   this.deps.featureFlagService.getFeatureEnabled("space_sharing");
    this.features.slashRemindCommand = this.deps.featureFlagService.getFeatureEnabled("slash_remind_command");
  }
}
